export class VehicleVersionMenuItem {
    oems: String[];
    brands: String[];
    vehicleIds: number[];
    nameplates: String[];

    constructor(oems: String[], brands: String[], vehicleIds: number[], nameplates: String[]){
        this.oems = oems;
        this.brands = brands;
        this.vehicleIds = vehicleIds;
        this.nameplates = nameplates;
    }
}